const calculateDollarStackDisplay = function(dollar_amount) {
  var remainder, containsRemainder, denominations = [], dollarStack = [];
  switch(true) {
    case(dollar_amount < 50):
      var remainder10 = dollar_amount % 10;
      var stacks10 = parseInt((dollar_amount - remainder10) / 10);
      denominations.push({count: stacks10, repeatedValue: 10});
      remainder = remainder10;
      break;
    case((dollar_amount > 50) && (dollar_amount < 100)):
      var remainder20 = dollar_amount % 20;
      var stacks20 = parseInt((dollar_amount - remainder20) / 20);
      denominations.push({count: stacks20, repeatedValue: 20});
      remainder = remainder20;
      break;
    case((dollar_amount > 100) && (dollar_amount < 500)):
      var remainder100 = dollar_amount % 100;
      var stacks100 = parseInt((dollar_amount - remainder100) / 100);
      var remainder50 = remainder100 % 50;
      var stacks50 = parseInt((remainder100 - remainder50) / 50);
      denominations.push({count: stacks100, repeatedValue: 100});
      denominations.push({count: stacks50, repeatedValue: 50});
      remainder = remainder50;
      break;
    case((dollar_amount > 500) && (dollar_amount < 2000)):
      var remainder500 = dollar_amount % 500;
      var stacks500 = parseInt((dollar_amount - remainder500) / 500);
      var remainder100 = remainder500 % 100;
      var stacks100 = parseInt((remainder500 - remainder100) / 100);
      denominations.push({count: stacks500, repeatedValue: 500});
      denominations.push({count: stacks100, repeatedValue: 100});
      remainder = remainder100;
      break;
    case((dollar_amount > 2000) && (dollar_amount < 5000)):
      var remainder1000 = dollar_amount % 1000;
      var stacks1000 = parseInt((dollar_amount - remainder1000) / 1000);
      var remainder500 = remainder1000 % 500;
      var stacks500 = parseInt((remainder1000 - remainder500) / 500);
      denominations.push({count: stacks1000, repeatedValue: 1000});
      denominations.push({count: stacks500, repeatedValue: 500});
      remainder = remainder500;
      break;
    case((dollar_amount > 5000) && (dollar_amount < 20000)):
      var remainder5000 = dollar_amount % 5000;
      var stacks5000 = parseInt((dollar_amount - remainder5000) / 5000);
      var remainder1000 = remainder5000 % 1000;
      var stacks1000 = parseInt((remainder5000 - remainder1000) / 1000);
      denominations.push({count: stacks5000, repeatedValue: 5000});
      denominations.push({count: stacks1000, repeatedValue: 1000});
      remainder = remainder1000;
      break;
    case((dollar_amount > 20000) && (dollar_amount < 50000)):
      var remainder10000 = dollar_amount % 10000;
      var stacks10000 = parseInt((dollar_amount - remainder10000) / 10000);
      var remainder5000 = remainder10000 % 5000;
      var stacks5000 = parseInt((stacks10000 - remainder5000) / 5000);
      denominations.push({count: stacks10000, repeatedValue: 10000});
      denominations.push({count: stacks5000, repeatedValue: 5000});
      remainder = remainder5000;
      break;
    case((dollar_amount > 50000) && (dollar_amount < 200000)):
      var remainder50000 = dollar_amount % 50000;
      var stacks50000 = parseInt((dollar_amount - remainder50000) / 50000);
      var remainder10000 = remainder50000 % 10000;
      var stacks10000 = parseInt((remainder50000 - remainder10000) / 10000);
      denominations.push({count: stacks50000, repeatedValue: 50000});
      denominations.push({count: stacks10000, repeatedValue: 10000});
      remainder = remainder10000;
      break;
    case((dollar_amount > 200000) && (dollar_amount < 500000)):
      var remainder100000 = dollar_amount % 100000;
      var stacks100000 = parseInt((dollar_amount - remainder100000) / 100000);
      var remainder50000 = stacks100000 % 50000;
      var stacks50000 = parseInt((stacks100000 - remainder50000) / 50000);
      denominations.push({count: stacks100000, repeatedValue: 100000});
      denominations.push({count: stacks50000, repeatedValue: 50000});
      remainder = remainder50000;
      break;
    default:
      remainder = dollar_amount;
  }
  if (remainder > 0) {
    containsRemainder = true;
    denominations.push({count: 1, repeatedValue: remainder});
  }
  for(var i in denominations) {
    var stack = denominations[i];
    if(stack.count === 0) {
      delete denominations[i];
    }
    else {
      for(var j = 1; j <= stack.count; j++) {
        dollarStack.push({
          val: stack.repeatedValue
        });
      }
    }
  }
  return dollarStack.reverse();
}

const templateUrl = require('./../views/partials/savings-card.html');

function savingsCardDirective($timeout) {
  'ngInject';

  return {
    scope: {
      savings: '&',
    },
    templateUrl,
    restrict: 'E',
    link: function(scope, el, attrs) {
      var $bills = $('.bills');
      scope.bills = {
        subscribers: 0,
        subscriber: 0
      };
      scope.savings = scope.savings();

      scope.bills.subscribers = calculateDollarStackDisplay(scope.savings.subscribers);
      scope.bills.subscriber = calculateDollarStackDisplay(scope.savings.subscriber);

      scope.activeStack = 'subscriber';

      scope.$watch(function() {
        return scope.activeStack;
      }, function(n, o) {
        if(n) {
          $bills.removeClass('stacked');
          scope.dollars = scope.bills[n];
          $timeout(function() {
            $bills.addClass('stacked');
          }, 100);
        }
      });
    }
  };
}

export default savingsCardDirective;



// WEBPACK FOOTER //
// ./js/containers/dashboard/directives/savingsCard.js